define.alias("ember-math-helpers/helpers/clz32", "media/helpers/clz32");